export class MessageNotEditableError extends Error {
  constructor() {
    super('Message is no longer editable')
    this.name = 'MessageNotEditableError'
  }
}

export class EditTextMessageFailedError extends Error {
  constructor(message?: string) {
    super(message || 'Edit text message failed')
    this.name = 'EditTextMessageFailedError'
  }
}
